import styled from "styled-components";

export const Hint = styled.p`
  color: var(--font-color2);
  font-size: 0.8em;
  line-height: 1.2em;
`;

export default Hint;
